export const TAX_CURRENCY = 'Tax Currency';

export const COMPANY_CODE_TYPE_VALUE = 'CC';
export const COMPANY_CODE_TYPE = {
  label: 'Company Codes',
  value: COMPANY_CODE_TYPE_VALUE,
};

export const AGGREGATION_DROPLIST_ITEMS = {
  ACCOUNT: 'account',
  DEFERRED_GROUP: 'deferredGroup',
  FOOTNOTE: 'footnote',
};

export const VIEW_TYPES = [
  {
    value: AGGREGATION_DROPLIST_ITEMS.ACCOUNT,
    label: 'View by Account',
  },
  {
    value: AGGREGATION_DROPLIST_ITEMS.DEFERRED_GROUP,
    label: 'View by Deferred Group',
  },
  {
    value: AGGREGATION_DROPLIST_ITEMS.FOOTNOTE,
    label: 'View by Footnote',
  },
];

export const allCountryTaxes = {
  label: 'All Country Taxes',
  value: 'ALL-ALL',
};
